const CONFIG = {
  BASE_URL: 'https://kbti-api.herokuapp.com',
};

export default CONFIG;
